import type { DocumentTemplatePayload } from '@Application/Documents/Templates/Actions/documentTemplatesFetched';

// Same shape as a template list entry: the whole template, current version included.
export type DocumentTemplateUpdatedPayload = DocumentTemplatePayload;

export type DocumentTemplateUpdatedAction = {
	type: 'DOCUMENT_TEMPLATE_UPDATED';
	payload: DocumentTemplateUpdatedPayload;
	organizationId: number;
};

export default (
	payload: DocumentTemplateUpdatedPayload,
	organizationId: number,
): DocumentTemplateUpdatedAction => ({
	type: 'DOCUMENT_TEMPLATE_UPDATED',
	payload,
	organizationId,
});
